// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xi33w","toggleWrap":"styles_toggleWrap__2yY76","content":"styles_content__1FGT1","selectAreaCode":"styles_selectAreaCode__233bY"};